import { useCallback } from 'react'
// import BigNumber from 'bignumber.js'
import { useTokenContract } from './useContract'
import { fromWei } from '../utils'

export const useTotalSupply = (tokenAddress: string | undefined): (() => Promise<number>) => {
  const tokenContract = useTokenContract(tokenAddress)

  const callback = useCallback(async (): Promise<number> => {
    let result = 0
    try {
      if (tokenContract) {
        const _balance = await tokenContract.methods.totalSupply().call()
        result = Number(fromWei(_balance))
      }
    } catch (error: any) {
      console.error(error)
    }

    return result
  }, [tokenContract])

  return callback
}
